import axiosClient from "../../../../api/axiosClient";

const BASE_URL = "/api/ppe/material-flow";

const approvalService = {

  getPendingApprovals: async () => {
    const response = await axiosClient.get(
      `${BASE_URL}/pending`
    );
    return response.data;
  },

  approve: async (transactionId, remarks) => {
    const response = await axiosClient.post(
      `${BASE_URL}/approve`,
      {
        transaction_id: transactionId,
        remarks,
      }
    );

    return response.data;
  },

  reject: async (transactionId, remarks) => {
    const response = await axiosClient.post(
      `${BASE_URL}/reject`,
      {
        transaction_id: transactionId,
        remarks,
      }
    );

    return response.data;
  },
};

export default approvalService;